import { motion } from "framer-motion";
import { Chapter, Reveal } from "./Reveal";
import { SKILLS } from "../../data/portfolio";

export const Skills = () => {
  return (
    <section
      id="skills"
      className="relative bg-[#EEEAE2] border-y border-[#1F2D3D]/10 py-24 md:py-36"
      data-testid="skills-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Chapter num="03" label="Capabilities" />

        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl font-semibold tracking-tight mb-16 max-w-3xl">
            A toolkit built across{" "}
            <span className="text-[#5E7E9B]">disciplines.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 border-t border-l border-[#1F2D3D]/10">
          {SKILLS.map((group, i) => (
            <motion.div
              key={group.category}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
              className="group relative border-r border-b border-[#1F2D3D]/10 p-8 hover:bg-[#1F2D3D]/[0.03] transition-colors duration-300"
              data-testid={`skill-group-${group.category}`}
            >
              <div className="flex items-center gap-3 mb-6">
                <span className="font-mono text-xs text-[#5E7E9B]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-xl font-medium group-hover:text-[#5E7E9B] transition-colors">
                  {group.category}
                </h3>
              </div>
              <ul className="space-y-4">
                {group.items.map((item) => (
                  <li key={item.name} className="flex gap-3">
                    <span className="h-px w-4 bg-[#5E7E9B]/50 mt-2.5 shrink-0" />
                    <div>
                      <span className="text-[#1F2D3D] text-sm font-medium">{item.name}</span>
                      <p className="text-[#7A8492] text-xs leading-relaxed mt-0.5">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
